import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import * as moment from "moment";
import { Day, DayMaker } from "../../models/day.model";
import { Week, WeekMaker } from "../../models/week.model";
import { Charge } from "../../models/charge.model";
import * as firebase from "firebase/app";
import { Params } from "../../pages/params";
import { LoadingController, Events, NavParams } from "ionic-angular";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { environment } from "../../environments/environment";
import { CsvService } from "angular2-json2csv";
import { GlobalProvider } from "../global/global";
import QRCode from "qrcode";

/*
  Generated class for the FoodsProvider provider.
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

const VeganLogoUrl = "/assets/img/vegan-icon.jpg";

@Injectable()
export class FoodsProvider {
  days: Array<Day> = [];
  weeks: Array<Week> = [];
  customers = [];
  activeDay: Day;
  recipes = [];
  empty_table = {
    margin: [0, 0, 0, 20],
    columns: [
      {
        width: "25%",
        fontSize: 8,
        table: {
          widths: ["*"],
          body: [
            [
              {
                text: "Información",
                alignment: "center",
                bold: true,
                fillColor: "lightgray",
              },
            ],
            [{ text: "", fillColor: "lightgray", margin: [0, 0, 0, 10] }],
          ],
        },
      } as any,
      {
        width: "60%",
        style: "tableExample",
        fontSize: 8,
        table: {
          widths: ["*", "auto", "auto", "auto", "auto", "auto"],
          body: [
            [
              {
                text: "Ingredientes",
                alignment: "center",
                bold: true,
                fillColor: "lightgray",
              },
              {
                text: "Teórico Crudo",
                alignment: "center",
                bold: true,
                fillColor: "lightgray",
              },
              {
                text: "Solicitado",
                alignment: "center",
                bold: true,
                fillColor: "lightgray",
              },
              {
                text: "Entregas",
                colSpan: 2,
                alignment: "center",
                bold: true,
                fillColor: "lightgray",
              },
              "",
              {
                text: "Observaciones",
                alignment: "center",
                bold: true,
                fillColor: "lightgray",
              },
            ],
            [
              {
                text: "",
                fillColor: "lightgray",
              },
              {
                text: "",
                fillColor: "lightgray",
              },
              {
                text: "",
                fillColor: "lightgray",
              },
              {
                text: "Entregado",
                alignment: "center",
                bold: true,
                fillColor: "lightgray",
              },
              {
                text: "Adicional",
                alignment: "center",
                bold: true,
                fillColor: "lightgray",
              },
              { text: "", fillColor: "lightgray" },
            ],
          ],
        },
        margin: [0, 0, 10, 0],
      } as any,
      {
        width: "auto",
        fontSize: 8,
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: "Detalle porciones",
                colSpan: 2,
                alignment: "center",
                bold: true,
                fillColor: "lightgreen",
              },
              "",
            ],
            [
              {
                text: "Porciones",
                alignment: "center",
                bold: true,
                fillColor: "lightgreen",
              },
              {
                text: "Gramos",
                alignment: "center",
                bold: true,
                fillColor: "lightgreen",
              },
            ],
          ],
        },
      } as any,
    ],
  };
  constructor(
    private http: Http,
    public loadingCtrl: LoadingController,
    public events: Events,
    private _csvService: CsvService,
    public global: GlobalProvider
  ) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    console.log("Hello FoodsProvider Provider");
    const start = moment().subtract(1, "days");
    const tempWeeks = [];
    let week;
    for (let i = 0; i < 6; i++) {
      let d = moment(start).add(i, "days");
      const weekCode = this.getWeekCode(d);
      if (tempWeeks.indexOf(weekCode) === -1) {
        tempWeeks.push(weekCode);
        week = WeekMaker.create({
          week: moment(d).week(),
          weekCode: weekCode,
          http: this.http,
        });
        this.weeks.push(week);
      }
      this.days.push(
        DayMaker.create({
          day: d,
          week: week,
          weekCode: weekCode,
          active: false,
        })
      );
    }
    console.log(this.days);

    for (let i = 0; i < this.weeks.length; i++) {
      this.weeks[i].load().then(() => {
        console.log("week load");
      });

      /* this.getWeek(this.weeks[i].weekCode) */
    }
    /* this.activeDay = this.days[0];
    this.activeDay.active = true; */

    firebase
      .database()
      .ref("/customers")
      .once("value")
      .then((snap) => {
        this.customers = snap.val();
      });

    this.recipes = this.global.recipes;
  }

  moreDays() {
    const start = moment(this.days[0].dayMDY).subtract(1, "days");
    const tempWeeks = [];
    const tempWeeks2 = [];
    let week;
    for (let i = 0; i < 3; i++) {
      let d = moment(start).subtract(i, "days");
      const weekCode = this.getWeekCode(d);
      if (tempWeeks.indexOf(weekCode) === -1) {
        tempWeeks.push(weekCode);
        week = WeekMaker.create({
          week: moment(d).week(),
          weekCode: weekCode,
          http: this.http,
        });
        this.weeks.push(week);
        tempWeeks2.push(week);
      }
      this.days.unshift(
        DayMaker.create({
          day: d,
          week: week,
          weekCode: weekCode,
          active: false,
        })
      );
    }
    console.log(this.days);

    for (let i = 0; i < tempWeeks2.length; i++) {
      tempWeeks2[i].load().then(() => {
        console.log("week load");
      });
    }
  }

  getWeekCode(today) {
    return (
      moment(today).endOf("week").format("YYYY") + "W" + moment(today).week()
    );
  }

  process(day) {
    let loading = this.loadingCtrl.create({
      content: "Este proceso dura aproximadamente 1 minuto. Espere porfavor...",
    });
    loading.present();
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .currentUser.getIdToken(true)
        .then((idToken) => {
          this.http
            .post(environment.urlService + "/processSubscriptions", {
              day: day.dayYMD,
              token: idToken,
              foods: day.foods,
            })
            .subscribe(
              (ok) => {
                resolve(true);
                console.log("ok", ok.json());
                loading.dismiss();
              },
              (err) => {
                resolve(false);
                console.log(err.message);
                loading.dismiss();
              }
            );
        })
        .catch((error) => {
          console.log(`error completo ${error}`);
          console.log(error.message);
        });
    });
  }

  calcProdCost(prod, factors) {
    console.log("calcProdCost");
    let total = 0;
    prod.recipes_extra.map((r) => {
      total = total + r.cost;
    });
    prod.recipes_uniques.map((r) => {
      let portion = r.portion ? r.portion : factors.v;
      let cost = Math.abs((r.cost * portion) / 100);
      total = total + cost;
    });
    prod.recipes_principal.map((r) => {
      let portion = r.portion ? r.portion : factors.p;
      let cost = Math.abs((r.cost * portion) / 100);
      total = total + cost;
    });
    prod.recipes_accompaniment.map((r) => {
      let portion = r.portion ? r.portion : factors.a;
      let cost = Math.abs((r.cost * portion) / 100);
      total = total + cost;
    });
    return total;
  }

  setCustomProd(prod) {
    prod.id = "9999";
    prod.description =
      "Conocemos tus gustos y restricciones, por lo mismo hemos reemplazado este producto. ";
    if (prod.imageList.length > 0) {
      prod.imageList[0].downloadURL =
        "https://firebasestorage.googleapis.com/v0/b/fitfood-22c23.appspot.com/o/default.jpg?alt=media&token=8a657592-a9c9-42f0-8e2c-1a15e18dc467";
    }
    prod.family = [];
    prod.chefwords = "";
    prod.category = "";
    prod.package = "";
    return prod;
  }

  calcProdNutritionals(prod, factors) {
    console.log(factors);
    prod.nutritional = {
      Kcal: 0,
      Cho: 0,
      Sodio: 0,
      Lip: 0,
      Pro: 0,
    };
    prod.recipes_uniques.map((r) => {
      let portion = r.portion ? r.portion : factors.v;
      prod.nutritional.Kcal = Math.round(
        prod.nutritional.Kcal + Math.abs((portion * r.nutritional.Kcal) / 100)
      );
      prod.nutritional.Pro = Math.round(
        prod.nutritional.Pro + Math.abs((portion * r.nutritional.Pro) / 100)
      );
      prod.nutritional.Lip = Math.round(
        prod.nutritional.Lip + Math.abs((portion * r.nutritional.Lip) / 100)
      );
      prod.nutritional.Cho = Math.round(
        prod.nutritional.Cho + Math.abs((portion * r.nutritional.Cho) / 100)
      );
      prod.nutritional.Sodio = Math.round(
        prod.nutritional.Sodio + Math.abs((portion * r.nutritional.Sodio) / 100)
      );
    });
    prod.recipes_principal.map((r) => {
      let portion = r.portion ? r.portion : factors.p;
      prod.nutritional.Kcal = Math.round(
        prod.nutritional.Kcal + Math.abs((portion * r.nutritional.Kcal) / 100)
      );
      prod.nutritional.Pro = Math.round(
        prod.nutritional.Pro + Math.abs((portion * r.nutritional.Pro) / 100)
      );
      prod.nutritional.Lip = Math.round(
        prod.nutritional.Lip + Math.abs((portion * r.nutritional.Lip) / 100)
      );
      prod.nutritional.Cho = Math.round(
        prod.nutritional.Cho + Math.abs((portion * r.nutritional.Cho) / 100)
      );
      prod.nutritional.Sodio = Math.round(
        prod.nutritional.Sodio + Math.abs((portion * r.nutritional.Sodio) / 100)
      );
    });
    prod.recipes_accompaniment.map((r) => {
      let portion = r.portion ? r.portion : factors.a;
      prod.nutritional.Kcal = Math.round(
        prod.nutritional.Kcal + Math.abs((portion * r.nutritional.Kcal) / 100)
      );
      prod.nutritional.Pro = Math.round(
        prod.nutritional.Pro + Math.abs((portion * r.nutritional.Pro) / 100)
      );
      prod.nutritional.Lip = Math.round(
        prod.nutritional.Lip + Math.abs((portion * r.nutritional.Lip) / 100)
      );
      prod.nutritional.Cho = Math.round(
        prod.nutritional.Cho + Math.abs((portion * r.nutritional.Cho) / 100)
      );
      prod.nutritional.Sodio = Math.round(
        prod.nutritional.Sodio + Math.abs((portion * r.nutritional.Sodio) / 100)
      );
    });
    return prod;
  }

  updateCustomers() {
    let loading = this.loadingCtrl.create({
      content: "Buscando cambios...",
    });
    loading.present();
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .currentUser.getIdToken(true)
        .then((idToken) => {
          this.http
            .post(environment.urlService + "/updateSubscriptions", {
              day: this.activeDay.dayYMD,
              token: idToken,
              foods: this.activeDay.foods,
            })
            .subscribe(
              (ok) => {
                this.activeDay.loading = true;
                this.activeDay.load().then(() => {
                  console.log("detect"!);
                  this.activeDay.charge.filtered =
                    this.activeDay.charge.data.filter(
                      (x) => x.shipping.delivered
                    );
                });
                console.log("ok", ok.json());
                loading.dismiss();
              },
              (err) => {
                resolve(false);
                console.log(err.message);
                loading.dismiss();
              }
            );
        })
        .catch((error) => {
          console.log(error.message);
        });
    });
  }

  printBagTags(size) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    console.log("print", this.activeDay);
    let loading = this.loadingCtrl.create({
      content: "Generando Etiquetas...",
    });
    loading.present();
    const de = {
      content: [],
      pageSize: {
        width: 265,
        height: 668,
      }, //small
      pageMargins: [50, 10, 100, 10],
      styles: {
        table: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
        },
      },
    };
    const dd = {
      content: [],
      pageSize: {
        width: 487,
        height: 567,
      },
      pageMargins: [20, 32, 10, 10],
      styles: {
        table: {
          fontSize: 11,
          margin: [0, 0, 0, 0],
        },
      },
    };
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    console.log(d);

    const customers = d.sort((a, b) => {
      if (a["dispatch"]["route"] > b["dispatch"]["route"]) {
        return 1;
      } else if (a["dispatch"]["route"] < b["dispatch"]["route"]) {
        return -1;
      }
    });

    for (let c = 0; c < customers.length; c++) {
      de.content.push({
        style: "table",
        table: {
          headerRows: 0,
          widths: ["200", "200"],
          body: [
            [
              {
                border: [false, false, false, false],
                text:
                  customers[c].customer.name +
                  " " +
                  customers[c].customer.lastname,
                bold: true,
                fontSize: 9,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: "Dirección:" + customers[c].dispatch.address,
                fontSize: 6,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: "Adicional :" + customers[c].dispatch.address_info,
                fontSize: 7,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text:
                  "Ruta :" +
                  customers[c].dispatch.route +
                  ". Comidas: " +
                  customers[c].foods.detail.length,
              },
            ],
          ],
        },
      });
      de.content[de.content.length - 1].table.body.push([
        { border: [false, false, false, false], text: "www.fitfood.cl " },
      ]);
      de.content.push({ text: "", margin: [0, 32, 0, 8] });

      dd.content.push({
        text: customers[c].customer.name + " " + customers[c].customer.lastname,
        bold: true,
        fontSize: 11,
      });
      dd.content.push({
        style: "table",
        table: {
          headerRows: 0,
          widths: [110, 2, "*"],
          body: [
            [
              "Dirección",
              ":",
              { text: customers[c].dispatch.address, fontSize: 9 },
            ],
            ["Adicional", ":", { text: customers[c].dispatch.address_info }],
            [
              { text: "Ruta: " + customers[c].dispatch.route },
              "",
              { text: "Comidas: " + customers[c].foods.detail.length },
            ],
          ],
        },
        layout: "lightHorizontalLines",
      });
      dd.content.push({ text: "www.fitfood.cl" });
      dd.content.push({ text: "", margin: [0, 22, 0, 8] });
    }
    console.log(de);
    loading.dismiss();

    if (size === "small") {
      pdfMake.createPdf(de).open();
    }

    if (size === "big") {
      pdfMake.createPdf(dd).open();
    }
  }

  printTagsCSV() {
    const foods_print = [];
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    for (let c of d) {
      for (let f of c.foods.detail) {
        const cook_day = moment(this.activeDay.dayMDY).subtract(1, "days");
        const venc = moment(cook_day).add(4, "days").format("DD-MM-YYYY");
        let prodName = "";
        let recipes = "[]";
        if (Object.keys(f.prod).length) {
          prodName = f.prod.name;
          recipes = this.getCodes(f.prod);
        }
        const condition = c.customer.conditions[f.code]
          ? c.customer.conditions[f.code]
          : "";
        const restrictions = this.getRestrictions(c.customer.restrictions);

        let hasRestriction = false;
        if (c.foods.restrictions.detail.length) {
          const find = c.foods.restrictions.detail.filter(
            (x) => x.prod == f.prod.id
          );
          if (find.length) {
            hasRestriction = !find[0].solved;
          }
        }

        if (f.prod) {
          if (f.prod.id == 9999) {
            hasRestriction = true;
          }
        }

        foods_print.push({
          Cliente: Params.parse_xls(
            c.customer.name + " " + c.customer.lastname
          ),
          Comida: f.name,
          Producto: Params.parse_xls(prodName),
          Plan: c.customer.plan.code,
          Porciones:
            c.customer.portions.principal +
            "-" +
            c.customer.portions.accompaniment +
            "-" +
            c.customer.portions.unique,
          Condicion: condition,
          CodigoComida: f.code,
          Recetas: recipes,
          IdProducto: f.prod ? f.prod.id : "",
          Restricciones: Params.parse_xls(restrictions),
          Ruta: c.dispatch.route,
          Vencimiento: venc,
          Restriccion: hasRestriction,
          Genero: c.customer.gender,
        });
      }
    }
    this._csvService.download(
      foods_print,
      "Etiquetas_" +
      this.activeDay.dayData["d"] +
      "-" +
      this.activeDay.dayData["m"] +
      "-" +
      this.activeDay.dayData["y"]
    );
  }

  printTags(order, size) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    console.log("print", this.activeDay);
    let loading = this.loadingCtrl.create({
      content: "Generando Etiquetas...",
    });
    loading.present();
    const dd = {
      content: [],
      pageSize: {
        width: 487,
        height: 567,
      },
      //left, top, right, bottom
      pageMargins: [20, 32, 10, 10],
      styles: {
        table: {
          fontSize: 11,
          margin: [0, 0, 0, 0],
        },
      },
    };
    const de = {
      content: [],
      pageSize: {
        width: 265,
        height: 668,
      }, //small
      pageMargins: [50, 10, 100, 10],
      styles: {
        table: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
        },
      },
    };
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    const foods_print = [];
    for (let c of d) {
      for (let f of c.foods.detail) {
        const cook_day = moment(this.activeDay.dayMDY).subtract(1, "days");
        const venc = moment(cook_day).add(4, "days").format("DD-MM-YYYY");
        let prodName = "";
        let recipes = "[]";
        if (Object.keys(f.prod).length) {
          prodName = f.prod.name;
          recipes = this.getCodes(f.prod);
        }
        const condition = c.customer.conditions[f.code]
          ? c.customer.conditions[f.code]
          : "";
        const restrictions = this.getRestrictions(c.customer.restrictions);

        let hasRestriction = false;
        if (c.foods.restrictions.detail.length) {
          const find = c.foods.restrictions.detail.filter(
            (x) => x.prod == f.prod.id
          );
          if (find.length) {
            hasRestriction = !find[0].solved;
          }
        }

        if (f.prod) {
          if (f.prod.id == 9999) {
            hasRestriction = true;
          }
        }

        foods_print.push({
          name: c.customer.name + " " + c.customer.lastname,
          foodName: f.name,
          prodName,
          planName: c.customer.plan.code,
          portions:
            c.customer.portions.principal +
            "-" +
            c.customer.portions.accompaniment +
            "-" +
            c.customer.portions.unique,
          condition,
          foodCode: f.code,
          recipes,
          prod_id: f.prod ? f.prod.id : "",
          restrictions,
          route: c.dispatch.route,
          cookDay: cook_day,
          venc,
          hasRestriction,
          gender: c.customer.gender,
        });
      }
    }

    const normal_foods = foods_print.filter((x) => !x.hasRestriction);
    normal_foods.sort((a, b) => {
      if (a[order] > b[order]) {
        return 1;
      } else if (a[order] < b[order]) {
        return -1;
      }

      if (a["gender"] < b["gender"]) {
        return -1;
      } else if (a["gender"] > b["gender"]) {
        return 1;
      } else {
        return 0;
      }
    });
    const rest_foods = foods_print.filter((x) => x.hasRestriction);
    rest_foods.sort((a, b) => {
      if (a[order] > b[order]) {
        return 1;
      } else if (a[order] < b[order]) {
        return -1;
      }

      if (a["gender"] < b["gender"]) {
        return -1;
      } else if (a["gender"] > b["gender"]) {
        return 1;
      } else {
        return 0;
      }
    });
    const finally_foods = normal_foods.concat(rest_foods);

    for (let c of finally_foods) {
      let r = c.restrictions;
      let rplus = "";
      if (c.restrictions.length > 32) {
        r = c.restrictions.substr(0, 32);
        rplus = c.restrictions.substr(32, c.restrictions.length);
      }

      de.content.push({
        style: "table",
        table: {
          headerRows: 0,
          widths: ["200", "200"],
          body: [
            [
              {
                border: [false, false, false, false],
                text: c.name + " (" + c.cookDay.format("DD-MM-YYYY") + ")",
                bold: true,
                fontSize: 9,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: c.prodName.substr(0, 40),
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: "Condición :" + c.condition,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: "Restricción :" + r,
                fontSize: 6,
                color: "red",
              },
            ],
          ],
        },
      });
      if (c.restrictions.length > 32) {
        de.content[de.content.length - 1].table.body.push([
          {
            border: [false, false, false, false],
            text: rplus,
            fontSize: 6,
            color: "red",
          },
        ]);
      }
      if (c.restrictions.length < 32) {
        de.content[de.content.length - 1].table.body.push([
          { border: [false, false, false, false], text: "Ruta : " + c.route },
        ]);
      }
      de.content.push({ text: "", margin: [0, 32, 0, 8] });

      dd.content.push({
        columns: [
          { text: c.name, bold: true, fontSize: 11 },
          {
            text: c.planName,
            fontSize: 11,
            alignment: "right",
          },
        ],
      });
      let color = "black";
      if (c.hasRestriction) color = "red";
      dd.content.push({
        style: "table",
        table: {
          headerRows: 0,
          widths: [110, 2, "*", 110],
          body: [
            [
              { text: c.foodName.substr(0, 22), fontSize: 10 },
              ":",
              { text: c.prodName.substr(0, 40), fontSize: 9, color: color },
              {
                text: c.portions,
                alignment: "right",
                fontSize: 10,
              },
            ],
            [
              "Condición",
              ":",
              { text: c.condition, fontSize: 9 },
              {
                text: c.foodCode + " " + c.recipes,
                alignment: "right",
                fontSize: 7,
              },
            ],
            [
              "Restricción",
              ":",
              {
                text: c.restrictions.substr(0, 100),
                color: "red",
                fontSize: 7,
              },
              {
                text: "Ruta:" + c.route,
                alignment: "right",
              },
            ],
          ],
        },
        layout: "lightHorizontalLines",
      });
      dd.content.push({
        text:
          "Fecha elaboración: " +
          c.cookDay.format("DD-MM-YYYY") +
          " / Consumir antes de: " +
          c.venc,
        fontSize: 10,
      });
      dd.content.push({ text: "", margin: [0, 22, 0, 8] });
    }
    console.log("TAMAÑO", size, typeof size);

    if (size === "small") {
      pdfMake.createPdf(de).open();
    }

    if (size === "big") {
      pdfMake.createPdf(dd).open();
    }

    loading.dismiss();
  }

  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      try {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
          var reader = new FileReader();
          reader.onloadend = function () {
            resolve(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
      } catch (e) {
        reject(e);
      }
    });
  }

  async printTagsT(order) {
    console.log("print", this.activeDay);
    let loading = this.loadingCtrl.create({
      content: "Generando Etiquetas...",
    });
    loading.present();
    const families = this.global.foods.reduce(
      (acc, item) => ((acc[item.value] = item.family), acc),
      {}
    );
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    const foods_print = [];
    for (let c of d) {
      for (let f of c.foods.detail) {
        const cook_day = moment(this.activeDay.dayMDY).subtract(1, "days");
        const venc = moment(cook_day).add(3, "days").format("DD-MM-YYYY");
        let prodName = "";
        let recipes = "[]";
        if (Object.keys(f.prod).length) {
          prodName = f.prod.name;
          recipes = this.getCodes(f.prod);
        }
        const condition = c.customer.conditions[f.code]
          ? c.customer.conditions[f.code]
          : "";
        const restrictions = this.getRestrictions(c.customer.restrictions);

        let hasRestriction = false;
        if (c.foods.restrictions.detail.length) {
          const find = c.foods.restrictions.detail.filter(
            (x) => x.prod == f.prod.id
          );
          if (find.length) {
            hasRestriction = !find[0].solved;
          }
        }

        if (f.prod) {
          if (f.prod.id == 9999) {
            hasRestriction = true;
          }
        }

        foods_print.push({
          name: c.customer.name + " " + c.customer.lastname,
          foodName: f.name,
          email: c.customer.email,
          prodName,
          planName: c.customer.plan.name + " " + c.customer.plan.code,
          portions:
            c.customer.portions.principal +
            "-" +
            c.customer.portions.accompaniment +
            "-" +
            c.customer.portions.unique,
          condition,
          foodCode: f.code,
          recipes,
          prod_id: f.prod ? f.prod.id : "",
          restrictions,
          route: c.dispatch.route,
          cookDay: cook_day,
          venc,
          hasRestriction,
          gender: c.customer.gender,
        });
      }
    }

    const normal_foods = foods_print.filter((x) => !x.hasRestriction);
    normal_foods.sort((a, b) => {
      if (order === "foodCode") {
        if (families[a[order]] < families[b[order]]) {
          return -1;
        } else if (families[a[order]] > families[b[order]]) {
          return 1;
        }
      }
      if (a[order] > b[order]) {
        return 1;
      } else if (a[order] < b[order]) {
        return -1;
      }

      if (a["route"] < b["route"]) {
        return -1;
      } else if (a["route"] > b["route"]) {
        return 1;
      }

      if (a["gender"] < b["gender"]) {
        return -1;
      } else if (a["gender"] > b["gender"]) {
        return 1;
      } else {
        return 0;
      }
    });

    const rest_foods = foods_print.filter((x) => x.hasRestriction);
    rest_foods.sort((a, b) => {
      if (order === "foodCode") {
        if (families[a[order]] < families[b[order]]) {
          return -1;
        } else if (families[a[order]] > families[b[order]]) {
          return 1;
        }
      }
      if (a[order] > b[order]) {
        return 1;
      } else if (a[order] < b[order]) {
        return -1;
      }

      if (a["route"] < b["route"]) {
        return -1;
      } else if (a["route"] > b["route"]) {
        return 1;
      }

      if (a["gender"] < b["gender"]) {
        return -1;
      } else if (a["gender"] > b["gender"]) {
        return 1;
      } else {
        return 0;
      }
    });
    const finally_foods = normal_foods.concat(rest_foods);

    const VeganLogo = await this.getBase64ImageFromURL(VeganLogoUrl).catch(
      (err) => {
        console.log(err);
        return null;
      }
    );

    const dd = {
      content: [],
      pageMargins: [10, 10, 10, 10],
      pageSize: {
        width: 550,
        height: 200,
      },
      background: (currentPage, pageSize) => {
        const tag = finally_foods[currentPage - 1];
        console.log({ currentPage, pageSize, tag });

        if (!tag) return null;

        if (VeganLogo && tag.planName.includes("VG")) {
          return {
            image: VeganLogo,
            width: 35,
            absolutePosition: { x: 505, y: 155 },
          };
        }
      },
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 10, 0, 10],
        },
        table: {
          fontSize: 12,
          width: 50,
        },
      },
    };

    for (let c of finally_foods) {
      let r = c.restrictions;
      let rplus = "";
      if (c.restrictions.length > 32) {
        r = c.restrictions.substr(0, 32);
        rplus = c.restrictions.substr(32, c.restrictions.length);
      }
      const qr = await QRCode.toDataURL(
        "https://app.fitfood.cl/qualify?user=" +
        c.email +
        "&product=" +
        c.prod_id +
        "&d=" +
        c.cookDay.format("YYYY[W]MMDD")
      );

      dd.content.push({
        pageBreak: "after",
        columns: [
          {
            width: 140,
            table: {
              body: [
                [
                  {
                    text: c.portions,
                    border: [0, 0, 0, 0],
                    alignment: "center",
                    bold: true,
                  },
                ],
                [
                  {
                    text: "Escanea el QR y califícame",
                    border: [0, 0, 0, 0],
                    alignment: "center",
                    fontSize: 8,
                  },
                ],
                [
                  {
                    width: 123,
                    border: [0, 0, 0, 0],
                    alignment: "center",
                    image: qr,
                  },
                ],

                [
                  {
                    text: "RUTA " + c.route,
                    alignment: "center",
                    bold: true,
                    fontSize: 10,
                  },
                ],
              ],
            },
          },
          {
            width: "*",
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    text: c.name,
                    border: [0, 0, 0, 0],
                    fontSize: 14,
                    bold: true,
                  },
                ],
                [
                  {
                    text: [c.foodName, { text: " " + c.prodName, bold: false }],
                    border: [0, 0, 0, 0],
                    bold: true,
                  },
                ],
                /*[
                  {
                    text: "Kcal: 0 Lip:0 Carb:0 Prot:0",
                    border: [0,0,0,0]
                  }
                ] */
                [
                  {
                    border: [0, 0, 0, 0],
                    margin: [0, 0, 0, 0],
                    table: {
                      body: [
                        [
                          {
                            text: "Código Recetas:",
                            bold: true,
                            margin: [0, 0, 0, 0],
                            border: [0, 0, 0, 0],
                            fontSize: 10,
                          },
                          {
                            text: c.recipes,
                            margin: [0, 0, 0, 0],
                            border: [0, 0, 0, 0],
                            fontSize: 10,
                          },
                        ],
                      ],
                    },
                  },
                ],
                [
                  {
                    table: {
                      body: [
                        [
                          {
                            text: "Restricción:",
                            bold: true,
                            border: [0, 0, 0, 0],
                            fontSize: 10,
                          },
                        ],
                        [
                          {
                            text: c.restrictions,
                            border: [0, 0, 0, 0],
                            fontSize: 11,
                          },
                        ],
                      ],
                    },
                  },
                ],
                [
                  {
                    text: `Plan: ${c.planName}`,
                    bold: true,
                    border: [0, 0, 0, 0],
                    fontSize: 10,
                  },
                ],
                [
                  {
                    text:
                      "Elab: " +
                      c.cookDay.format("DD-MM-YYYY") +
                      " / " +
                      "Venc:" +
                      c.venc,
                    border: [0, 0, 0, 0],
                    fontSize: 10,
                  },
                ],
              ],
            },
          },
        ],
      });
    }

    pdfMake.createPdf(dd).open();

    loading.dismiss();
  }

  exportRestrictionsCSV() {
    const ok = [];
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    for (let c of d) {
      if (c.foods.restrictions.detail.length) {
        const name = c.customer.name + " " + c.customer.lastname;
        for (let e of c.foods.restrictions.detail) {
          const includeRestriction = (f) => {
            /* Que aparezcan las restricciones de productos modificados pero no las de recetas modificadas */
            const recipe = f.prod[e.recipeType].length > 0 ? f.prod[e.recipeType][0] : null;
            return f.prod.id == e.prod || (recipe && recipe.code == e.recipeCode && e.solution.type !== 3)
          }
          const p = c.foods.detail.filter(includeRestriction);
          if (p.length) {
            let restriction_name = e.restriction.value_name;
            if (e.restriction.type == 2) restriction_name = e.ingName;
            let color = "black";
            if (e.restriction.reason_value === 1) color = "red";

            const t = {
              Cliente: Params.parse_xls(name),
              Revisar: Params.parse_xls(restriction_name),
              Comida: Params.parse_xls(p[0].name),
              Receta: Params.parse_xls(e.recipeName),
              Motivo: e.restriction.reason,
              Ruta: c.dispatch.route,
              Resuelto: "No",
              Solucion: "",
            };

            if (e.solved) {
              t.Resuelto = "Si";

              if (e.solution) {
                if (e.solution.type == 1) {
                  const f = p[0].prod[e.recipeType].filter(
                    (f) => f.id == e.solution.newRecipe
                  );
                  if (f.length) {
                    t.Solucion =
                      "Cambio de receta por " + Params.parse_xls(f[0].name);
                  } else {
                    console.error(
                      "Cambio receta no encontrado",
                      e.recipeType,
                      p[0].prod
                    );
                  }
                }
                if (e.solution.type == 2) {
                  t.Solucion =
                    "Quitar ingrediente " +
                    Params.parse_xls(e.solution.ingredient);
                }

                if (e.solution.type == 3) {
                  t.Solucion = "Nuevo producto custom";
                }
              }
            }
            ok.push(t);
          }
        }
      }
    }
    ok.sort((a, b) => {
      if (a.Comida > b.Comida) {
        return 1;
      } else if (a.Comida < b.Comida) {
        return -1;
      }

      if (a.Revisar < b.Revisar) {
        return -1;
      } else if (a.Revisar > b.Revisar) {
        return 1;
      } else {
        return 0;
      }
    });
    this._csvService.download(
      ok,
      "Restricciones_" +
      this.activeDay.dayData["d"] +
      "-" +
      this.activeDay.dayData["m"] +
      "-" +
      this.activeDay.dayData["y"]
    );
  }

  exportRestrictionsPDF() {
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    let de = {
      content: [],
      pageOrientation: "landscape",
      styles: {
        table: {
          fontSize: 8,
          margin: [0, 5, 0, 15],
        },
      },
      defaultStyle: {
        fontSize: 8,
        bold: true,
      },
    };
    de.content.push({
      text: "Listado Restricciones",
      bold: true,
      fontSize: 14,
    });
    de.content.push({
      text:
        this.activeDay.dayLong +
        " " +
        this.activeDay.dayData["d"] +
        " de " +
        this.activeDay.dayData["m"] +
        " " +
        this.activeDay.dayData["y"],
      bold: true,
      fontSize: 18,
    });
    de.content.push({ text: "", margin: [0, 22, 0, 8] });

    const table = {
      table: {
        headerRows: 1,
        widths: ["*", "*", "*", "*", "auto", "auto", "auto", 200],
        body: [
          [
            { text: "Cliente", style: "tableHeader" },
            { text: "Revisar", style: "tableHeader" },
            { text: "Comida", style: "tableHeader" },
            { text: "Receta", style: "tableHeader" },
            { text: "Motivo", style: "tableHeader" },
            { text: "Ruta", style: "tableHeader" },
            { text: "Resuelto", style: "tableHeader" },
            { text: "Solución", style: "tableHeader" },
          ],
        ],
      },
    };

    let temp = [];
    for (let c of d) {
      if (c.foods.restrictions.detail.length) {
        const name = c.customer.name + " " + c.customer.lastname;
        for (let e of c.foods.restrictions.detail) {
          const includeRestriction = (f) => {
            /* Que aparezcan las restricciones de productos modificados pero no las de recetas modificadas */
            const recipe = f.prod[e.recipeType].length > 0 ? f.prod[e.recipeType][0] : null;
            return f.prod.id == e.prod || (recipe && recipe.code == e.recipeCode && e?.solution?.type !== 3)
          }
          const p = c.foods.detail.filter(includeRestriction);
          if (p.length) {
            let restriction_name = e.restriction.value_name;
            if (e.restriction.type == 2) restriction_name = e.ingName;
            let color = "black";
            if (e.restriction.reason_value === 1) color = "red";

            const t = [
              { text: name, color: color },
              { text: restriction_name, color: color },
              { text: p[0].name, color: color },
              { text: e.recipeName, color: color },
              { text: e.restriction.reason, color: color },
              { text: c.dispatch.route, color: color },
              "No",
              "",
            ];

            if (e.solved) {
              t[6] = "Si";

              if (e.solution) {
                if (e.solution.type == 1) {
                  const f = p[0].prod[e.recipeType].filter(
                    (f) => f.id == e.solution.newRecipe
                  );
                  if (f.length) {
                    t[7] = "Cambio de receta por " + f[0].name;
                  } else {
                    console.error(
                      "Cambio receta no encontrado",
                      p[0].prod[e.recipeType],
                      e.solution.newRecipe
                    );
                  }
                }
                if (e.solution.type == 2) {
                  t[7] = "Quitar ingrediente " + e.solution.ingredient;
                }

                if (e.solution.type == 3) {
                  t[7] = "Nuevo producto custom";
                }
              }
            }
            temp.push(t);
          }
        }
      }
    }
    console.log(temp);
    temp.sort((a, b) => {
      if (a[2].text > b[2].text) {
        return 1;
      } else if (a[2].text < b[2].text) {
        return -1;
      }

      if (a[1].text < b[1].text) {
        return -1;
      } else if (a[1].text > b[1].text) {
        return 1;
      } else {
        return 0;
      }
    });

    table.table.body = table.table.body.concat(temp);
    de.content.push(table);
    pdfMake.createPdf(de).open();
  }

  printNewTags() {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    console.log("print");
    let loading = this.loadingCtrl.create({
      content: "Generando Etiquetas...",
    });
    loading.present();
    const dd = {
      content: [],
      pageSize: {
        width: 487,
        height: 567,
      },
      pageMargins: [20, 10, 10, 10],
      styles: {
        table: {
          fontSize: 11,
          margin: [0, 0, 0, 0],
        },
      },
    };
    const de = {
      content: [],
      pageSize: "FITFOODSMALL",
      pageMargins: [50, 10, 100, 10],
      styles: {
        table: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
        },
      },
    };
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    for (let c of d) {
      for (let f of c.foods.detail) {
        const cook_day = moment(this.activeDay.day).subtract(1, "days");
        const venc = moment(cook_day).add(3, "days").format("DD-MM-YYYY");
        let prodName = "";
        let recipes = "[]";
        if (Object.keys(f.prod).length) {
          prodName = f.prod.name;
          recipes = this.getCodes(f.prod);
        }
        const condition = c.customer.conditions[f.code]
          ? c.customer.conditions[f.code]
          : "";
        const restrictions = this.getRestrictions(c.customer.restrictions);
        let lt = ["EH", "EHD", "SA", "SAF", "SAMD", "SAF"];

        if (lt.indexOf(f.code) != -1) {
          // debe ser dinámico
          let r = restrictions;
          let rplus = "";
          if (restrictions.length > 32) {
            r = restrictions.substr(0, 32);
            rplus = restrictions.substr(32, restrictions.length);
          }

          de.content.push({
            style: "table",
            table: {
              headerRows: 0,
              widths: ["200", "200"],
              body: [
                [
                  {
                    border: [false, false, false, false],
                    text: f.name + " (" + cook_day.format("DD-MM-YYYY") + ")",
                    bold: true,
                    fontSize: 9,
                  },
                ],
                [
                  {
                    border: [false, false, false, false],
                    text: c.customer.name + " " + c.customer.lastname,
                  },
                ],
                [
                  {
                    border: [false, false, false, false],
                    text: "Condición :" + condition,
                  },
                ],
                [
                  {
                    border: [false, false, false, false],
                    text: "Restricción :" + r,
                    fontSize: 6,
                    color: "red",
                  },
                ],
              ],
            },
          });
          if (restrictions.length > 32) {
            de.content[de.content.length - 1].table.body.push([
              {
                border: [false, false, false, false],
                text: rplus,
                fontSize: 6,
                color: "red",
              },
            ]);
          }
          if (restrictions.length < 32) {
            de.content[de.content.length - 1].table.body.push([
              {
                border: [false, false, false, false],
                text: "Ruta : " + c.dispatch.route,
              },
            ]);
          }
          de.content.push({ text: "", margin: [0, 32, 0, 8] });
        } else {
          dd.content.push({
            text: c.customer.name + " " + c.customer.lastname,
            bold: true,
            fontSize: 11,
          });
          dd.content.push({
            style: "table",
            table: {
              headerRows: 0,
              widths: [110, 2, "*", 110],
              body: [
                [
                  f.name,
                  ":",
                  { text: prodName, fontSize: 9 },
                  {
                    text: c.customer.plan.name,
                    alignment: "right",
                  },
                ],
                //['Condición', ':',{text:condition,fontSize:9}, {text: f.code+ " "+recipes, alignment: 'right', fontSize: 8}],
              ],
            },
            layout: "noBorders",
          });
          dd.content.push({
            style: "table",
            table: {
              headerRows: 0,
              widths: [50, 50, 50, 50, 50, 50, "*"],
              body: [
                [
                  {
                    text: f.prod.nutritional.Kcal,
                    fontSize: 8,
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: f.prod.nutritional.Pro + "g",
                    fontSize: 8,
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: f.prod.nutritional.Cho + "g",
                    fontSize: 8,
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: f.prod.nutritional.Lip + "g",
                    fontSize: 8,
                    alignment: "center",
                    bold: true,
                  },
                  {
                    text: f.prod.nutritional.Sodio + "mg",
                    fontSize: 8,
                    alignment: "center",
                    bold: true,
                  },
                  { text: "Porción:", fontSize: 8 },
                  { text: "180g + 150g", fontSize: 8 },
                ],
                [
                  { text: "Calorías", fontSize: 8, alignment: "center" },
                  { text: "Proteínas", fontSize: 8, alignment: "center" },
                  { text: "Carbo", fontSize: 8, alignment: "center" },
                  { text: "Lípidos", fontSize: 8, alignment: "center" },
                  { text: "Sodio", fontSize: 8, alignment: "center" },
                  "",
                  "",
                ],
              ],
            },
            layout: "exampleLayout",
          });
          dd.content.push({
            text:
              "Fecha elaboración: " +
              cook_day.format("DD-MM-YYYY") +
              " / Consumir antes de: " +
              venc,
            fontSize: 11,
          });
          dd.content.push({ text: "", margin: [0, 22, 0, 8] });
        }
      }
    }
    pdfMake.tableLayouts = {
      exampleLayout: {
        hLineWidth: function (i, node) {
          if (i === node.table.body.length) {
            return 1;
          } else {
            if (i === 0) {
              return 0;
            } else {
              return i === node.table.headerRows ? 2 : 1;
            }
          }
        },
        vLineWidth: function (i) {
          return 0;
        },
        hLineColor: function (i) {
          return "black";
        },
        paddingLeft: function (i) {
          return i === 0 ? 0 : 7;
        },
        paddingRight: function (i, node) {
          return i === node.table.widths.length - 1 ? 0 : 8;
        },
      },
    };
    pdfMake.createPdf(dd).open();
    pdfMake.createPdf(de).open();
    loading.dismiss();
  }

  getRestrictions(rest) {
    let txt = "";
    for (let r of rest) {
      if ([1, 2].indexOf(r.type) != -1) {
        //ingredient
        txt += r.value_name + ", ";
      }
      if ([3, 4].indexOf(r.type) != -1) {
        // recipe
        txt += r.value + ", ";
      }
    }
    txt = txt.slice(0, -2);
    return txt;
  }

  getCodes(prod) {
    const recipes = [];
    try {
      prod.recipes_uniques.map((r) => {
        recipes.push(r.code);
      });
      prod.recipes_principal.map((r) => {
        recipes.push(r.code);
      });
      prod.recipes_accompaniment.map((r) => {
        recipes.push(r.code);
      });
      // prod.recipes_extra.map((r)=>{ recipes.push(r.code); });
    } catch (e) {
      console.log(e, prod);
    }
    return JSON.stringify(recipes);
  }

  supplies() {
    console.log("contadores");
    let ings = {};
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    for (let c of d) {
      for (let f of c.foods.detail) {
        if (Object.keys(f.prod).length) {
          f.prod.recipes_uniques.map((r) => this.sumIngredients(r, ings));
          f.prod.recipes_principal.map((r) => this.sumIngredients(r, ings));
          f.prod.recipes_accompaniment.map((r) => this.sumIngredients(r, ings));
          f.prod.recipes_extra.map((r) => this.sumIngredients(r, ings));
        }
      }
    }

    let de = {
      content: [],
      styles: {
        table: {
          fontSize: 7,
          margin: [0, 5, 0, 15],
        },
      },
      defaultStyle: {
        fontSize: 8,
        bold: true,
      },
    };
    de.content.push({ text: "Listado de Insumos", bold: true, fontSize: 14 });
    de.content.push({
      text:
        this.activeDay.dayLong +
        " " +
        this.activeDay.dayData["d"] +
        " de " +
        this.activeDay.dayData["m"] +
        " " +
        this.activeDay.dayData["y"],
      bold: true,
      fontSize: 18,
    });
    de.content.push({ text: "", margin: [0, 22, 0, 8] });

    const table = {
      table: {
        headerRows: 1,
        widths: ["auto", "*", "auto", 50, 50, 50, 50, 50],
        heights: 16,
        body: [
          [
            { text: "Código", bold: true },
            { text: "Ingrediente", bold: true },
            { text: "Total Teórico", bold: true },
            { text: "Total Solicitado", bold: true },
            { text: "Total Entregado", bold: true },
            { text: "Extras", bold: true },
            { text: "Devolución", bold: true },
            { text: "Merma", bold: true },
          ],
        ],
      },
    };
    const aIngs = Object.keys(ings)
      .map((i) => {
        return { code: i, ...ings[i] };
      })
      .sort((a, b) => {
        if (a.total > b.total) return -1;
        if (a.total < b.total) return 1;
        return 0;
      });

    console.log(aIngs);
    for (let r of aIngs) {
      table.table.body.push([
        r.code,
        r.name,
        (r.total / 1000).toFixed(3) + r.measure,
        "",
        "",
        "",
        "",
        "",
      ]);
    }
    de.content.push(table);
    de.content.push({ text: "", margin: [0, 52, 0, 8] });
    de.content.push({
      table: {
        headerRows: 0,
        widths: ["*", "*"],
        body: [
          [
            { text: "Nombre encargado", alignment: "center" },
            { text: "Firma encargado", alignment: "center" },
          ],
        ],
      },
    });
    pdfMake.createPdf(de).open();
  }

  weekSupplies(data) {
    console.log(this.weeks);
    console.log(data);

    const week = this.weeks.filter((x) => x.weekCode == data)[0];

    /* console.log('contadores');
    let ings = {};
    const d = this.activeDay.charge.data.filter((item)=>item.shipping.delivered);
    for(let c of d) {
      for (let f of c.foods.detail) {
        if(Object.keys(f.prod).length){
          f.prod.recipes_uniques.map((r)=>this.sumIngredients(r,ings));
          f.prod.recipes_principal.map((r)=>this.sumIngredients(r,ings));
          f.prod.recipes_accompaniment.map((r)=>this.sumIngredients(r,ings));
          f.prod.recipes_extra.map((r)=>this.sumIngredients(r,ings));
        }
      }
    }
    let de = {
      content: [],
      styles: {
        table: {
          "fontSize": 7,
          "margin": [0, 5, 0, 15],
        }
      },
      defaultStyle: {
        fontSize: 8,
        bold: true
      }
    };
    de.content.push({text: "Listado de Insumos", bold: true,fontSize: 14});
    de.content.push({text: this.activeDay.dayLong + ' ' + this.activeDay.dayData['d'] + ' de '+this.activeDay.dayData['m'] + ' ' + this.activeDay.dayData['y'], bold: true,fontSize: 18});
    de.content.push({text: '', margin: [0, 22, 0, 8]});

    const table = {
      table:{
        headerRows: 1,
        widths: ['auto', '*','auto',50,50,50,50,50],
        heights: 16,
        body: [
          [
            {text: 'Código', bold: true},
            {text: 'Ingrediente', bold: true},
            {text: 'Total Teórico', bold: true},
            {text: 'Total Solicitado', bold: true},
            {text: 'Total Entregado', bold: true},
            {text: 'Extras', bold: true},
            {text: 'Devolución', bold: true},
            {text: 'Merma', bold: true},
          ]
        ]
      }
    }
    const aIngs = Object.keys(ings)
      .map((i)=>{ return {code:i, ...ings[i]} })
      .sort((a, b) => {
        if(a.total > b.total) return -1;
        if(a.total < b.total) return 1;
        return 0;
      });

    console.log(aIngs);
    for(let r of aIngs){
      table.table.body.push([
        r.code,
        r.name,
        (r.total/1000).toFixed(3)+r.measure,
        '',
        '',
        '',
        '',
        ''
      ]);
    }
    de.content.push(table);
    de.content.push({text: '', margin: [0, 52, 0, 8]});
    de.content.push({
      table:{
        headerRows: 0,
        widths: ['*', '*'],
        body: [
          [
            {text: "Nombre encargado",alignment: 'center'},
            {text: "Firma encargado",alignment: 'center'}
          ]
        ]
      }
    })
    pdfMake.createPdf(de).open(); */
  }

  counters() {
    console.log("contadores", this.activeDay.charge);
    let recipes = {};
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    for (let c of d) {
      for (let f of c.foods.detail) {
        if (Object.keys(f.prod).length) {
          f.prod.recipes_uniques.map((r) => this.sumRecipe(r, recipes));
          f.prod.recipes_principal.map((r) => this.sumRecipe(r, recipes));
          f.prod.recipes_accompaniment.map((r) => this.sumRecipe(r, recipes));
          f.prod.recipes_extra.map((r) => this.sumRecipe(r, recipes));
        }
      }
    }
    console.log("e1", recipes);

    let de = {
      content: [],
      styles: {
        table: {
          fontSize: 8,
          margin: [0, 5, 0, 15],
        },
      },
      defaultStyle: {
        fontSize: 8,
        bold: true,
      },
    };
    de.content.push({ text: "Informe a cocina", bold: true, fontSize: 14 });
    de.content.push({
      text:
        this.activeDay.dayLong +
        " " +
        this.activeDay.dayData["d"] +
        " de " +
        this.activeDay.dayData["m"] +
        " " +
        this.activeDay.dayData["y"],
      bold: true,
      fontSize: 18,
    });
    de.content.push({ text: "", margin: [0, 22, 0, 8] });

    const aRecipes = Object.keys(recipes)
      .map((i) => {
        return { code: i, ...recipes[i] };
      })
      .sort((a, b) => {
        if (a.totalg > b.totalg) return -1;
        if (a.totalg < b.totalg) return 1;
        return 0;
      });
    console.log(aRecipes);

    const table = {
      table: {
        headerRows: 1,
        widths: ["auto", "auto", "auto", "auto"],
        body: [
          [
            { text: "Receta", bold: true },
            { text: "Cant. a cocinar", bold: true },
            { text: "Tot. Porciones", bold: true },
            { text: "Detalle Porciones", bold: true },
          ],
        ],
      },
    };

    for (let r of aRecipes) {
      const table_portions = {
        table: {
          headerRows: 1,
          widths: ["auto", "auto"],
          body: [
            [
              { text: "Porciones", bold: true },
              { text: "Gramos", bold: true },
            ],
          ],
        },
      };

      for (let p in r.portions) {
        table_portions.table.body.push([r.portions[p], p + "g"]);
      }

      table.table.body.push([
        r.name,
        this.gramsFormat(r.totalg),
        r.total,
        table_portions,
      ]);
    }
    de.content.push(table);
    pdfMake.createPdf(de).open();
  }

  report() {
    console.log("contadores", this.activeDay.charge);
    let recipes = {};
    const d = this.activeDay.charge.data.filter(
      (item) => item.shipping.delivered
    );
    for (let c of d) {
      for (let f of c.foods.detail) {
        if (Object.keys(f.prod).length) {
          // f.code
          f.prod.recipes_uniques.map((r) => this.sumRecipe(r, recipes));
          f.prod.recipes_principal.map((r) => this.sumRecipe(r, recipes));
          f.prod.recipes_accompaniment.map((r) => this.sumRecipe(r, recipes));
          f.prod.recipes_extra.map((r) => this.sumRecipe(r, recipes));
        }
      }
    }
    console.log("e1", recipes);

    const dd = {
      pageOrientation: "landscape",
      content: [
        {
          text: "Acta diaria de producción",
          fontSize: 20,
          alignment: "center",
          margin: [0, 0, 0, 0],
        } as any,
        {
          text:
            "Fecha: " +
            this.activeDay.dayLong +
            " " +
            this.activeDay.dayData["d"] +
            " de " +
            this.activeDay.dayData["m"] +
            " " +
            this.activeDay.dayData["y"],
          fontSize: 12,
          alignment: "center",
          margin: [0, 0, 0, 20],
        } as any,
        /* {
          text:'Área: Repostería',
          fontSize:12,
          alignment:'center',
          margin:[0,0,0,20]
        } as any, */
      ],
    };

    const aRecipes = Object.keys(recipes)
      .map((i) => {
        return { code: i, ...recipes[i] };
      })
      .sort((a, b) => {
        if (a.code < b.code) return -1;
        if (a.code > b.code) return 1;
        return 0;
      });
    console.log(aRecipes);

    let n = 0;
    for (let r of aRecipes) {
      n++;
      const table = JSON.parse(JSON.stringify(this.empty_table));
      for (let p in r.portions) {
        table.columns[2].table.body.push([r.portions[p], p + "g"]);
      }

      for (let i in r.ings) {
        table.columns[1].table.body.push([
          r.ings[i].name,
          this.gramsMLFormat(r.ings[i].total, r.ings[i].measure),
          "",
          "",
          "",
          "",
        ]);
      }

      table.columns[0].table.body.push([{ text: "Nombre: " + r.name }]);
      table.columns[0].table.body.push([{ text: "Comida asociada: " }]);
      table.columns[0].table.body.push([
        { text: "Peso total cocido: " + this.gramsFormat(r.totalg) },
      ]);
      table.columns[0].table.body.push([{ text: "Porciones: " + r.total }]);
      table.columns[0].table.body.push([
        {
          text: "Completar",
          alignment: "center",
          bold: true,
          fillColor: "lightgray",
        },
      ]);
      table.columns[0].table.body.push([{ text: "Calificación info receta:" }]);
      table.columns[0].table.body.push([
        { text: "Merma final receta completa:" },
      ]);
      table.columns[0].table.body.push([{ text: "Raciones faltantes:" }]);
      if (!(n % 2)) {
        table.pageBreak = "after";
      }
      dd.content.push(table);
    }

    pdfMake.createPdf(dd).open();
  }

  gramsMLFormat(g, uw) {
    if (g > 1000 && uw != "un") {
      g = g / 1000;
    } else {
      if (uw == "kg") uw = "g";
      if (uw == "lt") uw = "ml";
    }

    if (g % 1 != 0) g = g.toFixed(2);
    return g + uw;
  }

  gramsFormat(g) {
    let r = "n/a";
    if (g > 1000) {
      r = (g / 1000).toFixed(2) + "kg";
    } else {
      r = g + "g";
    }
    return r;
  }

  sumIngredients(r, ings) {
    r.ingredients.map((i) => {
      if (r.calcportion) {
        if (ings[i.code]) {
          let total = (Number(i.gross) * r.calcportion) / 100;
          if (i.measure == "un") total = total / i.unitWeight;
          ings[i.code].total = ings[i.code].total + total;
        } else {
          let total = (Number(i.gross) * r.calcportion) / 100;
          if (i.measure == "un") total = total / i.unitWeight;
          ings[i.code] = {
            total: total,
            name: i.name,
            brand: i.brand,
            measure: i.measure,
          };
        }
      } else {
        console.error(r);
      }
    });
  }

  sumRecipe(r, recipes) {
    if (r.calcportion) {
      if (recipes[r.code]) {
        recipes[r.code].total++;
        recipes[r.code].totalg =
          Number(recipes[r.code].totalg) + Number(r.calcportion);
        if (recipes[r.code].portions[r.calcportion]) {
          recipes[r.code].portions[r.calcportion]++;
        } else {
          recipes[r.code].portions[r.calcportion] = 1;
        }
        this.sumIngredients(r, recipes[r.code].ings);
      } else {
        recipes[r.code] = {
          total: 1,
          portions: {},
          name: r.name,
          ings: {},
          totalg: r.calcportion,
        };
        recipes[r.code].portions[r.calcportion] = 1;
        this.sumIngredients(r, recipes[r.code].ings);
      }
    } else {
      console.error(r);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/foods/foods.ts